<template>
    <div>
        <h3 class="mb-5 custom-title">
            {{ service_name }}
        </h3>
        <v-card elevation="0" class="custom-title">
            <v-card-actions class="mt-5">
                <v-row>
                    <v-col cols="3">
                        <v-btn @click="back()" text style="font-weight:800;">BACK</v-btn>
                    </v-col>
                    <v-col cols="6" style="text-align:center;">
                        <v-btn class="add-btn" color="#3988AA" dark @click="openAddDialog()">
                            <v-icon left>mdi-plus</v-icon>
                            Add {{ service_name }}
                        </v-btn>
                    </v-col>
                    <v-col cols="3" style="text-align:right;">
                        <v-btn @click="save()" style="background-color:green;color:white;font-weight:800;">
                            NEXT
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-card v-for="(build, index) in builds" :key="index" outlined class="card-format mt-5">
            <v-card-text>
                <v-row dense v-if="grouped">
                    <v-col cols="12">
                        <div class="mb-3 sublabel">FILTER BY SUBTYPE</div>
                        <v-select v-model="build.subtype_filter" :items="type_groups" item-text="label"
                            item-value="build_index" placeholder="All subtypes" filled outlined dense clearable
                            @change="onSubtypeFilterChange(index)"></v-select>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="6">
                        <div class="mb-3 sublabel">ACTIVITY DAY</div>
                        <v-select v-model="build.start_date" :items="date_range" filled outlined dense>
                            <template v-slot:selection="{ item }">
                                <b>{{ $date(item).format('dddd, Do MMMM YYYY') }}</b>
                            </template>
                            <template v-slot:item="{ item }">
                                <b>{{ $date(item).format('dddd, Do MMMM YYYY') }}</b>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="6">
                        <div class="mb-3 sublabel">SELECT SUPPLIER</div>
                        <v-autocomplete v-model="build.supplier" :items="getSuppliersForBuild(build)"
                            @change="onSupplierChange(index)" item-text="supplier_name" return-object filled outlined
                            dense :disabled="build.start_date == null">
                            <template v-slot:selection="{ item }">
                                <b>{{ item.supplier_name }}</b>
                                <v-chip v-if="grouped" x-small class="ml-2">{{ groupLabel(item, build) }}</v-chip>
                            </template>
                            <template v-slot:item="{ item }">
                                <b>{{ item.supplier_name }}</b>
                                <v-chip v-if="grouped" x-small class="ml-2">{{ groupLabel(item, build) }}</v-chip>
                            </template>
                        </v-autocomplete>
                        <div v-if="unavailableNote(build)" class="unavailable-note">
                            <v-icon x-small color="#C62828" class="mr-1">mdi-calendar-remove</v-icon>{{ unavailableNote(build) }}
                        </div>
                    </v-col>
                </v-row>
                <v-row dense v-if="build.supplier">
                    <v-col cols="12" v-if="build.supplier.products == null">
                        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" v-else>
                        <v-row class="mb-2" no-gutters>
                            <v-col cols="6" class="pr-2">
                                <v-text-field v-model="build.product_search" placeholder="Search products..."
                                    prepend-inner-icon="mdi-magnify" filled outlined dense clearable
                                    hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-select v-model="build.product_location" :items="getProductLocations(build)"
                                    placeholder="Filter by location..." filled outlined dense clearable
                                    hide-details></v-select>
                            </v-col>
                        </v-row>
                        <v-data-table
                            :items="productsForBuild(build)"
                            :headers="product_header" hide-default-footer disable-pagination class="custom-table">
                            <template v-slot:item="{ item }">
                                <tr @click="selectOption(item, index)">
                                    <td>
                                        <input
                                            :checked="build.options.findIndex((options) => options.id == item.id) > -1 ? true : false"
                                            type="checkbox" style="pointer-events: none;">
                                    </td>
                                    <td>
                                        {{ item.name }}
                                        <span @click.stop class="type-select-wrap">
                                            <v-select
                                                :value="pending_type_selections[item.id] || productTypesFor(item, build)"
                                                @change="val => $set(pending_type_selections, item.id, val)"
                                                @blur="onTypeSelectBlur(item, build, index)"
                                                :items="booking_types" item-value="id" item-text="name"
                                                multiple dense hide-details chips small-chips
                                                :menu-props="{ closeOnContentClick: false }"
                                                class="type-select ml-2"></v-select>
                                        </span>
                                    </td>
                                    <td>{{ get_selected_company.currency }}{{ item.customer_price }}<span v-if="item.supplier_price_type == 1" title="Priced for the whole group: the quote divides it by the group size"> /group</span></td>
                                </tr>
                            </template>
                            <template v-slot:no-data>
                                No products match your search or filter.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="custom-buttons mb-5">
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="confirmRemove(index)"><small>Remove</small></v-btn>
            </v-card-actions>
        </v-card>
        <v-card elevation="0" class="custom-title" v-if="builds.length > 0">
            <v-card-actions class="mt-5">
                <v-row>
                    <v-col cols="3">
                        <v-btn @click="back()" text style="font-weight:800;">BACK</v-btn>
                    </v-col>
                    <v-col cols="6" style="text-align:center;">
                        <v-btn class="add-btn" color="#3988AA" dark @click="openAddDialog()">
                            <v-icon left>mdi-plus</v-icon>
                            Add {{ service_name }}
                        </v-btn>
                    </v-col>
                    <v-col cols="3" style="text-align:right;">
                        <v-btn @click="save()" style="background-color:green;color:white;font-weight:800;">
                            NEXT
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-dialog v-model="add_dialog" max-width="600px" persistent>
            <v-card>
                <v-card-title>Do you want to proceed in adding a new supplier?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="custom-buttons" text @click="closeAddDialog()">Cancel</v-btn>
                    <v-btn class="custom-buttons" dark @click="addBuild()">Add</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="remove_dialog" max-width="600px" persistent>
            <v-card>
                <v-card-title>Remove this {{ service_name.toLowerCase() }}? Any selected supplier and products will be lost.</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="custom-buttons" text @click="closeRemoveDialog()">Cancel</v-btn>
                    <v-btn class="custom-buttons" color="red" dark @click="removeBuild(remove_index)">Remove</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { unavailableBetween, unavailableLabel } from '../../../utils/supplierUnavailability'
export default {
    components: {
    },
    props: [
        'lead', 'date_range', 'suppliers', 'service_name', 'type_groups', 'edit_builds', 'quote_location', 'booking_types', 'type_step_lookup'
    ],
    data: () => ({
        builds: [],
        // In-progress edits for the type-select on each product row, keyed by product id.
        // The select updates this locally on every change so the dropdown reflects clicks
        // immediately, but the actual save (API call + move logic) only fires on blur, so
        // deselecting one type and picking another doesn't save an invalid in-between state.
        pending_type_selections: {},
        product_header: [
            { text: '', sortable: false },
            { text: 'ACTIVITY NAME', sortable: false },
            { text: 'PRICE', sortable: false }
        ],
        add_dialog: false,
        remove_dialog: false,
        remove_index: null,
    }),
    async mounted() {
    },
    created() {
    },
    computed: {
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
        }),
        grouped() {
            return this.type_groups && this.type_groups.length > 1
        },
    },
    watch: {
        edit_builds: {
            handler(newVal) {
                const hasData = newVal && Object.values(newVal).some((list) => list && list.length > 0)
                // Only run if we have new data and haven't loaded it yet
                if (hasData && this.builds.length === 0) {
                    this.$nextTick(() => {
                        this.getEditData()
                    })
                }
            },
            immediate: true
        }
    },
    methods: {
        getEditData() {
            if (!this.edit_builds) return
            // Flatten every type group's builds and sort by start_date (tie-break by the
            // group's position in type_groups, which already matches canonical type order)
            // so e.g. a Friday night activity shows before a Saturday day activity instead
            // of being grouped after it by type.
            const flattened = []
            this.type_groups.forEach((group, group_index) => {
                const list = this.edit_builds[group.build_index]
                if (!list) return
                list.forEach((build) => flattened.push({ group_index, build }))
            })
            flattened.sort((a, b) => {
                const a_date = a.build.start_date || ''
                const b_date = b.build.start_date || ''
                if (a_date !== b_date) return a_date < b_date ? -1 : 1
                return a.group_index - b.group_index
            })
            flattened.forEach(({ build }) => {
                this.addBuild()
                const index = this.builds.length - 1
                // Normalize date format to match date_range format (YYYY-MM-DD)
                const normalizedStartDate = build.start_date ? build.start_date.split('T')[0] : null
                const normalizedEndDate = build.end_date ? build.end_date.split('T')[0] : null
                this.$set(this.builds[index], 'start_date', normalizedStartDate)
                this.$set(this.builds[index], 'end_date', normalizedEndDate)
                this.$set(this.builds[index], 'supplier', build.supplier ? { ...build.supplier, products: null } : build.supplier)
                this.$set(this.builds[index], 'options', build.options)
                this.$set(this.builds[index], 'product_search', null)
                this.$set(this.builds[index], 'product_location', null)
                this.getSupplier(index)
            })
        },
        openAddDialog() {
            this.add_dialog = true
        },
        closeAddDialog() {
            this.add_dialog = false
        },
        addBuild() {
            this.builds.push({
                id: null,
                start_date: null,
                end_date: null,
                supplier: null,
                options: [],
                rates: [],
                product_search: null,
                product_location: null,
                subtype_filter: null,
            })
            this.closeAddDialog()
        },
        confirmRemove(index) {
            if (this.builds[index].supplier) {
                this.remove_index = index
                this.remove_dialog = true
            }
            else {
                this.removeBuild(index)
            }
        },
        closeRemoveDialog() {
            this.remove_dialog = false
            this.remove_index = null
        },
        removeBuild(index) {
            this.builds.splice(index, 1)
            this.closeRemoveDialog()
        },
        skip() {
            this.$emit('skip')
        },
        back() {
            this.$emit('back')
        },
        triggerSave() {
            this.$emit('saveWithoutScroll', this.buildMap(), null)
        },
        save() {
            this.$emit('save', this.buildMap(), null)
        },
        saveWithoutScroll() {
            this.$emit('saveWithoutScroll', this.buildMap(), null)
        },
        buildMap() {
            const map = {}
            this.type_groups.forEach((group) => {
                map[group.build_index] = []
            })
            this.builds.forEach((build) => {
                if (!build.options || build.options.length === 0) {
                    // Nothing selected yet - bucket by supplier so the in-progress card still
                    // renders somewhere while the user is still picking products.
                    const group = this.groupForSupplier(build.supplier) || this.type_groups[0]
                    map[group.build_index].push(build)
                    return
                }
                // Bucket by each option's actual resolved type rather than the supplier's type,
                // so the review/summary screens show exactly what will be persisted — a supplier
                // can offer options of different types under one build entry.
                const byBuildIndex = {}
                build.options.forEach((option) => {
                    const group = this.type_groups.find((g) => g.supplier_type === option.resolved_type_id) || this.groupForSupplier(build.supplier) || this.type_groups[0]
                    if (!byBuildIndex[group.build_index]) byBuildIndex[group.build_index] = []
                    byBuildIndex[group.build_index].push(option)
                })
                Object.keys(byBuildIndex).forEach((buildIndex) => {
                    map[buildIndex].push({ ...build, options: byBuildIndex[buildIndex] })
                })
            })
            return map
        },
        supplierTypesFor(supplier) {
            return (supplier.service_type_ids && supplier.service_type_ids.length) ? supplier.service_type_ids : [supplier.service_type_id]
        },
        groupForSupplier(supplier) {
            if (!supplier) return null
            const types = this.supplierTypesFor(supplier)
            return this.type_groups.find((group) => types.includes(group.supplier_type)) || null
        },
        groupLabel(item, build) {
            if (!item) return ''
            const allowed = this.allowedTypesForBuild(build)
            const types = this.supplierTypesFor(item).filter((t) => allowed.includes(t))
            return types.map((t) => (this.type_groups.find((g) => g.supplier_type === t) || {}).label).filter(Boolean).join(' + ')
        },
        allowedTypesForBuild(build) {
            const groups = (build.subtype_filter != null)
                ? this.type_groups.filter((group) => group.build_index === build.subtype_filter)
                : this.type_groups
            return groups.map((group) => group.supplier_type)
        },
        getSuppliersForBuild(build) {
            const allowed = this.allowedTypesForBuild(build)
            const current = build.supplier ? build.supplier.id : null
            return this.suppliers.filter((item) => {
                // Not offered on its unavailable dates; one already on the build stays (flagged).
                if (item.id !== current && unavailableBetween(item, build.start_date)) return false
                return this.supplierTypesFor(item).some((t) => allowed.includes(t))
            })
        },
        unavailableNote(build) {
            const supplier = build.supplier && this.suppliers.find((s) => s.id === build.supplier.id)
            return unavailableLabel(unavailableBetween(supplier, build.start_date))
        },
        productTypesFor(product, build) {
            return (product.service_type_ids && product.service_type_ids.length) ? product.service_type_ids : [build.supplier.service_type_id]
        },
        // The type-select only updates pending_type_selections as the user clicks options
        // (so the dropdown reflects the clicks), and saves here on blur — i.e. once they've
        // deselected/selected whatever they want and clicked off, not on every toggle.
        onTypeSelectBlur(item, build, buildIndex) {
            const pending = this.pending_type_selections[item.id]
            this.$delete(this.pending_type_selections, item.id)
            if (pending === undefined) return
            const current = (item.service_type_ids && item.service_type_ids.length) ? item.service_type_ids : [build.supplier.service_type_id]
            if (this.sameTypes(current, pending)) return
            this.onProductTypeChange(item, build, buildIndex, pending)
        },
        sameTypes(a, b) {
            const sortedA = [...a].map(Number).sort((x, y) => x - y)
            const sortedB = [...b].map(Number).sort((x, y) => x - y)
            return sortedA.length === sortedB.length && sortedA.every((v, i) => v === sortedB[i])
        },
        // Persists a product's booking type(s) via the same endpoint ProductEditPage uses
        // (which re-syncs the supplier's own service_type_ids server-side), then keeps this
        // build's selection and the other steps' product lists in sync with the change.
        async onProductTypeChange(product, build, buildIndex, newTypesRaw) {
            const newTypes = Array.from(new Set((newTypesRaw || []).map(Number))).sort((a, b) => a - b)
            if (newTypes.length === 0) {
                this.$toast.error('A product must have at least one booking type.')
                return
            }
            const oldTypes = product.service_type_ids ? [...product.service_type_ids] : []
            product.service_type_ids = newTypes
            try {
                const { data } = await this.$axios.post(`admin/suppliers/update_supplier_product/${product.id}`, {
                    service_type_ids: newTypes,
                })
                if (!data.response) {
                    throw new Error(data.message || 'Failed to update product type')
                }
            } catch (e) {
                product.service_type_ids = oldTypes
                this.$toast.error(e.message || 'Failed to update product type')
                return
            }
            // Same union-of-non-archived-products logic as the backend's syncSupplierServiceTypeIds,
            // so the supplier-level type chip/filtering (shared object, read by every step) stays correct
            // without a full supplier refetch.
            this.refreshSupplierUnion(build.supplier)

            // "First type" is scoped to wherever the option actually ends up: if any of the
            // newly-selected types still belong to this step, stay put and resolve to the
            // lowest of those (so resolved_type_id always matches a group in this step's own
            // type_groups); only fall back to the global lowest type — and a move — when none
            // of the selection belongs here any more.
            const in_step_types = newTypes.filter((t) => this.type_groups.some((g) => g.supplier_type === t))
            const stays_in_step = in_step_types.length > 0
            const primary_type = stays_in_step ? in_step_types[0] : newTypes[0]
            const target = this.type_step_lookup ? this.type_step_lookup[primary_type] : null
            const option_index = build.options.findIndex((o) => o.id == product.id)
            const was_selected = option_index > -1

            if (was_selected) {
                if (stays_in_step) {
                    this.$set(build.options, option_index, {
                        ...build.options[option_index],
                        service_type_ids: newTypes,
                        resolved_type_id: primary_type,
                    })
                } else {
                    const [moved_option] = build.options.splice(option_index, 1)
                    const updated_option = { ...moved_option, service_type_ids: newTypes, resolved_type_id: primary_type }
                    if (build.options.length === 0) {
                        this.builds.splice(buildIndex, 1)
                    }
                    this.$emit('moveOption', {
                        target_supplier_type: primary_type,
                        supplier: build.supplier,
                        start_date: build.start_date,
                        end_date: build.end_date,
                        option: updated_option,
                    })
                }
                this.saveWithoutScroll()
            }

            if (was_selected && !stays_in_step && target) {
                this.$toast.success(`Booking type updated — ${product.name} can now be found in the ${target.step_label} step.`, { timeout: 3000, icon: true })
            } else {
                this.$toast.success('Booking type updated.', { timeout: 2000, icon: true })
            }
        },
        refreshSupplierUnion(supplier) {
            const union = new Set()
            ;(supplier.products || []).forEach((p) => {
                if (p.archived == 0 && p.service_type_ids && p.service_type_ids.length) {
                    p.service_type_ids.forEach((t) => union.add(t))
                }
            })
            if (union.size > 0) {
                const sorted = Array.from(union).sort((a, b) => a - b)
                supplier.service_type_ids = sorted
                supplier.service_type_id = sorted[0]
            }
        },
        // Called by the parent when another step hands off a build/option whose type now
        // resolves into this step's own type_groups (e.g. this is the Activities step and
        // a product was just recategorized from Dinner to Day Activity).
        receiveMovedOption({ supplier, start_date, end_date, option }) {
            const existing_index = this.builds.findIndex((b) => b.supplier && b.supplier.id === supplier.id && b.start_date === start_date)
            if (existing_index === -1) {
                this.builds.push({
                    id: null,
                    start_date,
                    end_date,
                    supplier,
                    options: [option],
                    rates: [],
                    product_search: null,
                    product_location: null,
                    subtype_filter: null,
                })
            } else {
                const option_index = this.builds[existing_index].options.findIndex((o) => o.id == option.id)
                if (option_index > -1) {
                    this.$set(this.builds[existing_index].options, option_index, option)
                } else {
                    this.builds[existing_index].options.push(option)
                }
            }
            this.saveWithoutScroll()
        },
        productsForBuild(build) {
            const allowed = this.allowedTypesForBuild(build)
            return build.supplier.products.filter((x) => {
                const matchesType = this.productTypesFor(x, build).some((t) => allowed.includes(t)) || build.options.some((o) => o.id == x.id)
                return x.archived == 0 && matchesType
                    && (!build.product_search || x.name.toLowerCase().includes(build.product_search.toLowerCase()))
                    && (!build.product_location || !x.name.match(/\([^)]+\)/) || x.name.includes(build.product_location))
            }).slice().sort((a, b) => {
                const aSelected = build.options.findIndex((o) => o.id == a.id) > -1
                const bSelected = build.options.findIndex((o) => o.id == b.id) > -1
                return bSelected - aSelected
            })
        },
        onSubtypeFilterChange(index) {
            const build = this.builds[index]
            if (build.supplier) {
                const allowed = this.getSuppliersForBuild(build).some((s) => s.id === build.supplier.id)
                if (!allowed) {
                    build.supplier = null
                    build.options = []
                    build.product_search = null
                    build.product_location = null
                }
            }
        },
        matchedRate(option, index) {
            let matched_rate = null
            if (option.rates && option.rates[0] && this.builds[index].start_date && this.$date(this.builds[index].start_date).isBetween(option.rates[0].start_date, option.rates[0].end_date, null, '[]')) {
                option.rates[0].days.forEach(day => {
                    if (this.$date(this.builds[index].start_date).format('dddd') == day.day)
                        matched_rate = day.gross
                })
            }
            if (matched_rate) {
                return parseFloat(matched_rate)
            }
            else {
                return 0
            }
        },
        selectOption(option, index) {
            const build = this.builds[index]
            const optionIndex = build.options.findIndex((options) => options.id == option.id)
            if (optionIndex === -1) {
                const allowed = this.allowedTypesForBuild(build)
                const matches = this.productTypesFor(option, build).filter((t) => allowed.includes(t))
                if (matches.length > 1) {
                    this.$toast.error('This product is available under multiple types shown here — choose a Filter by Subtype first to specify which one to book it as.')
                    return
                }
                if (matches.length === 0) return
                build.options.push({ ...option, resolved_type_id: matches[0] })
            }
            else {
                build.options.splice(optionIndex, 1)
            }
        },
        onSupplierChange(index) {
            this.builds[index].options = []
            this.builds[index].product_search = null
            this.builds[index].product_location = null
            this.getSupplier(index)
        },
        getProductLocations(build) {
            if (!build.supplier || !build.supplier.products) return []
            const locations = new Set()
            build.supplier.products.forEach(p => {
                const match = p.name.match(/\(([^)]+)\)/)
                if (match) locations.add(match[1])
            })
            return Array.from(locations).sort()
        },
        applySupplierData(index, supplier) {
            this.builds[index].supplier = supplier
            supplier.products.forEach(product => {
                let option_index = this.builds[index].options.findIndex((options) => options.id == product.id)
                if (option_index > -1) {
                    this.builds[index].options[option_index].product_type = product.product_type
                }
            })
            if (this.builds[index].product_location === null && this.quote_location) {
                const availableLocations = this.getProductLocations(this.builds[index])
                const match = availableLocations.find(loc => loc.toLowerCase() === this.quote_location.name.toLowerCase())
                if (match) this.builds[index].product_location = match
            }
            this.saveWithoutScroll()
        },
        // The location's supplier list (this.suppliers) already carries every supplier's
        // products, so resolve from it instead of re-fetching one supplier at a time.
        // Only falls back to the network if a build's supplier has since dropped off that
        // location's list (e.g. its location assignment changed after the quote was saved).
        async getSupplier(index) {
            const current = this.builds[index].supplier
            if (!current) return
            const full = this.suppliers.find((s) => s.id === current.id)
            if (full) {
                this.applySupplierData(index, full)
                return
            }
            await this.$axios.get(`admin/suppliers/get_supplier/${current.id}`)
                .then(({ data }) => {
                    if (data.response) {
                        this.applySupplierData(index, data.data)
                    }
                })
        },
    }
}
</script>

<style lang="scss" scoped>
.unavailable-note {
    font-family: Manrope;
    font-size: 12px;
    font-weight: 600;
    color: #C62828;
    margin-top: 4px;
}

.card-format {
    padding: 24px;
    border-radius: 20px !important;

    .card-footer-format {
        border-top: 1px solid #E9E9E9;
        background-color: #E9E9E9;
    }
}

.card-footer-format {
    .pagination-font-format {
        font-family: 'Work Sans';
        font-size: 14px;
    }

    .bg-color-white {
        background-color: white;
    }
}

:deep(.v-input__slot) {
    background: white !important;
}

:deep(.v-stepper__header) {
    box-shadow: none !important;
}

.accom-price {
    color: #FAAF3A;
    font-size: 36px;
    font-weight: 600;
}

.custom-title {
    font-family: 'Manrope';
    font-size: 14px !important;
    color: #3988AA;
    font-weight: 600;
}

.sublabel {
    color: #7C7C7C;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.description {
    color: #7D7D7D;
    font-family: Manrope;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.summary {
    color: #7C7C7C;
    font-family: Manrope;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 20px;
}

:deep(.custom-buttons span) {
    font-family: Manrope;
    font-size: 13px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    box-shadow: none !important;
}

:deep(.custom-buttons button) {
    padding: 8px 7px 8px 7px !important;
    border-radius: 5px;
}

.custom-table {
    font-family: Manrope;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
    color: #101010;
    max-height: 400px;
    overflow-y: auto;
}

.type-select-wrap {
    display: inline-block;
    vertical-align: middle;
}

.type-select {
    display: inline-flex;
    min-width: 180px;
    max-width: 280px;
    vertical-align: middle;

    :deep(.v-input__slot) {
        min-height: 28px !important;
        padding: 2px 8px !important;
        box-shadow: none !important;
    }

    :deep(.v-input__slot:before),
    :deep(.v-input__slot:after) {
        border-style: none !important;
    }

    :deep(.v-select__selections) {
        min-height: 24px;
    }

    :deep(.v-chip) {
        margin: 1px 2px !important;
        height: 20px !important;
    }
}

.add-btn {
    font-family: Manrope;
    font-size: 14px !important;
    font-weight: 700 !important;
    text-transform: none;
    border-radius: 8px;
    padding: 0 20px !important;
}
</style>
